import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-08c0a6c5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fixed bg-white z-50 bg-opacity-50 inset-0 flex items-center justify-center p-4" }
const _hoisted_2 = { class: "fixed inset-0 overflow-y-auto" }
const _hoisted_3 = { class: "flex min-h-full items-center justify-center" }
const _hoisted_4 = { class: "grid grid-cols-2 gap-4 max-h-full overflow-y-auto" }
const _hoisted_5 = { class: "col-span-2 lg:col-span-1" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "col-span-2 lg:col-span-1 px-4" }
const _hoisted_8 = { class: "pb-8 flex gap-8" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "flex justify-between" }
const _hoisted_11 = { class: "flex justify-between -mx-4 -mb-4" }
const _hoisted_12 = { class: "flex justify-end pt-4" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Zapisz ")

import { reactive, computed, watch } from 'vue'
import { ButtonTypes } from '@/types/enums/button'
import { UploadedFileType } from '@/types/partials'
import { Dialog, DialogPanel, DialogTitle } from '@headlessui/vue'
import { UiTitle, UiCard, UiPagination, UiButton } from '@/components/common/ui'
import { useDocumentTypes } from '@/composables/useDocumentTypes'
import { useAdviceDocuments, AdviceInInvoiceDetails } from '@/composables/useAdviceDocuments'

interface IProps {
    attachment?: UploadedFileType
}

export default /*#__PURE__*/_defineComponent({
  props: {
    attachment: { type: null, required: false, default: undefined }
  },
  emits: ['close'],
  setup(__props: any, { emit }) {

const props = __props as { attachment: UploadedFileType }




const {
    selectedAdvices,
    paginatedAttachmentFiles,
    attachmentDescriptions,
    changePaginatedAttachmentDescription,
} = useAdviceDocuments()

const paginatedAttachment = computed(() => {
    return paginatedAttachmentFiles.value.find(paf => paf.attachmentId === props.attachment?.id)
})
const pagesMetaData = reactive({
    pageCount: 1,
    page: 1,
})
watch(
    paginatedAttachment,
    curr => {
        if (curr) {
            pagesMetaData.page = 1
            pagesMetaData.pageCount = curr.pageCount
            // auto bind if only one advice
            if (selectedAdvices.value.length === 1 && chosenAdviceIds.value.length === 0) {
                for (let page = 1; page <= pagesMetaData.pageCount; page++) {
                    const paginatedFromPage = paginatedAttachment.value?.paginatedFile[page - 1]
                    if (paginatedFromPage) {
                        changePaginatedAttachmentDescription(props.attachment.id, {
                            page,
                            filename: paginatedFromPage.filename,
                            base64: paginatedFromPage.img,
                            adviceId: selectedAdvices.value[0].id,
                        })
                    }
                }
            }
        }
    },
    { immediate: true },
)
const changePage = (p: number) => {
    pagesMetaData.page = p
}
const currentPage = computed(() => {
    return paginatedAttachment.value.paginatedFile[pagesMetaData.page - 1]
})

const chosenAdviceIds = computed(() => {
    const description = attachmentDescriptions.value.find(
        ad => ad.attachmentId === props.attachment?.id,
    )
    return description?.pages?.[pagesMetaData.page - 1]?.advice_ids || []
})
const setAdvice = (advice: AdviceInInvoiceDetails) => {
    // if only one advice then remove binding is unavailible because of auto binding
    if (selectedAdvices.value.length === 1) {
        return
    }
    changePaginatedAttachmentDescription(props.attachment.id, {
        page: pagesMetaData.page,
        filename: currentPage.value.filename,
        base64: currentPage.value.img,
        adviceId: advice.id,
    })
}

const { documentTypes, fetchDocumentTypes, isEmpty } = useDocumentTypes()
if (isEmpty.value) {
    fetchDocumentTypes()
}
const chosenDocTypes = computed(() => {
    const description = attachmentDescriptions.value.find(
        ad => ad.attachmentId === props.attachment?.id,
    )

    return description?.pages?.[pagesMetaData.page - 1]?.document_types || []
})
const setDoctype = (docType: number) => {
    changePaginatedAttachmentDescription(props.attachment.id, {
        page: pagesMetaData.page,
        filename: currentPage.value.filename,
        base64: currentPage.value.img,
        docType: docType,
    })
}

const saveDocumentWithAdvices = () => {
    /* TODO
        Zapis w tej chwili nie robi nic.
        1. Powinien sprawdzać czy do każdej strony dokumentu są przypisane przynajmniej 1 typ dokumentu i 1 zlecenie
        2. Poz zmienną attachmentDescriptions przechowywane są wszystkie załączniki z podziałem na strony i do każdej strony doppisane są nazwy plików,
        typy dokumentów i zlecenia - z tej zmiennej na zapisie w AddEditInvoice -> onInvoiceSave strony załącznikó powinny być dopisywane do body

        w payloadzie tej funkcji jest array 'attachemnts' powinien wyglądać tak:
        [
            {
                "filename": "string",
                "base64": "string",
                "advice_ids": [2137,420],
                "documenty_types"[1,2],
            }
        ]
        czyli być zbudowany z typów AttachmentDescription, dane do zapełnienia go są pod attachmentDescriptions.pages
        3. Po walidacji i zapisie button 'opisz' powinien zmienić się na 'opisany'
        4. Sprawdź działanie usuwania załączników, bo coś tam chyba nie styka
        5. Przydałby się loader podczas przetwarzania zipów
    */
    emit('close', false)
}

return (_ctx: any,_cache: any) => {
  const _component_IconCrossDark = _resolveComponent("IconCrossDark")!

  return (_openBlock(), _createBlock(_unref(Dialog), {
    as: "div",
    class: "relative",
    onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close', false)))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(DialogPanel), { class: "w-full max-w-7xl rounded bg-white p-8" }, {
              default: _withCtx(() => [
                _createVNode(_unref(DialogTitle), { class: "flex justify-between" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(UiTitle), { class: "mb-4" }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Opisz załącznik (" + _toDisplayString(props.attachment?.name) + ") ", 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(UiButton), {
                      "no-button-style": "",
                      "show-tooltip": "",
                      "tooltip-message": 'zamknij',
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close', false)))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_IconCrossDark, { class: "transform rotate-45" })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("img", {
                      src: _unref(currentPage)?.img
                    }, null, 8, _hoisted_6),
                    _createVNode(_unref(UiPagination), {
                      class: "justify-center",
                      metadata: _unref(pagesMetaData),
                      onChangePage: changePage
                    }, null, 8, ["metadata"])
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(documentTypes), (docType) => {
                        return (_openBlock(), _createBlock(_unref(UiButton), {
                          key: docType.symbol,
                          primary: _unref(chosenDocTypes).includes(docType.id),
                          type: _unref(ButtonTypes).BUTTON,
                          class: _normalizeClass(["hover:bg-primary hover:text-white", 
                                            _unref(chosenDocTypes).includes(docType.id)
                                                ? 'border-2 border-transparent'
                                                : ''
                                        ]),
                          onClick: ($event: any) => (setDoctype(docType.id))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(docType.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["primary", "type", "class", "onClick"]))
                      }), 128))
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(selectedAdvices), (advice, adviceIdx) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: adviceIdx,
                        class: "w-full",
                        onClick: ($event: any) => (setAdvice(advice))
                      }, [
                        _createVNode(_unref(UiCard), {
                          class: "cursor-pointer transition-shadow duration-300 hover:shadow-lg",
                          "custom-class": 
                                            _unref(chosenAdviceIds).includes(advice.id)
                                                ? 'bg-blue-bg border-blue'
                                                : ''
                                        
                        }, {
                          header: _withCtx(() => [
                            _createElementVNode("div", _hoisted_10, [
                              _createVNode(_unref(UiTitle), null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(advice.axId), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createTextVNode(" Data Wyładowania: " + _toDisplayString(advice.deliveryDate), 1)
                            ])
                          ]),
                          content: _withCtx(() => [
                            _createElementVNode("div", _hoisted_11, [
                              _createElementVNode("p", null, "Kierowca: " + _toDisplayString(advice.driver), 1),
                              _createElementVNode("p", null, " Nr rejestracyjny: " + _toDisplayString(advice.vehicleIdentificationNumber), 1)
                            ])
                          ]),
                          _: 2
                        }, 1032, ["custom-class"])
                      ], 8, _hoisted_9))
                    }), 128))
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_unref(UiButton), {
                    primary: "",
                    onClick: saveDocumentWithAdvices
                  }, {
                    default: _withCtx(() => [
                      _hoisted_13
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})